/**
 * vue alert install
 */
import Vue from 'vue'
import Alert from './Alert'
import Toast from './Toast'
import ActionSheet from './ActionSheet'
import Confirm from './Confirm'

let instance;

var AlertConstruct = Vue.extend(Alert)
var ToastConstruct = Vue.extend(Toast)
var ActionSheetConstruct = Vue.extend(ActionSheet)
var ConfirmConstruct = Vue.extend(Confirm)

let AlertInit = (options) => {

    var instance = new AlertConstruct({
        el: document.createElement('div')
    });

    Object.assign(instance.$data, options);

    document.body.appendChild(instance.$el);
    instance = null;
}

let ToastInit = (options) => {

    if (typeof options === "string") {
        options = {
            content: options
        }
    }

    var instance = new ToastConstruct({
        el: document.createElement('div')
    });

    Object.assign(instance.$data, options);

    document.body.appendChild(instance.$el);
    instance = null;
}


let ActionSheetInit = (options) => {

    var instance = new ActionSheetConstruct({
        el: document.createElement('div')
    });

    Object.assign(instance.$data, options);

    document.body.appendChild(instance.$el);
    instance = null;
}

let ConfirmInit = (options) => {

    var instance = new ConfirmConstruct({
        el: document.createElement('div')
    });

    Object.assign(instance.$data, options);

    document.body.appendChild(instance.$el);
    instance = null;
}

export default {
    install(Vue) {
        Vue.prototype.$alert = AlertInit;
        Vue.prototype.$toast = ToastInit;
        Vue.prototype.$actionSheet = ActionSheetInit;
        Vue.prototype.$confirm = ConfirmInit;
    }
}



// WEBPACK FOOTER //
// ./src/components/dialog/index.js